import { IApplicationState } from '../../../../types/types';
import { TBoardId } from '../../../../types/types';
import { getListViewBoard } from './getListViewBoard';

export const getGroupByEpics = (
    state: IApplicationState,
    boardId: TBoardId
): boolean => {
    const isGroupByEpics = getListViewBoard(state, boardId).isGroupByEpics;
    return isGroupByEpics;
}
